<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">알림 템플릿 작성</h4>
        </template>
        <div class="row">
          <label class="col-sm-2 col-form-label">알림명</label>
          <div class="col-sm-4">
            <base-input placeholder="알림명" v-model="name" disabled>
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-10">
            <div class="row">
              <div class="col-sm-2">언어</div>
              <div class="col-sm-4">푸시 알림 타이틀</div>
              <div class="col-sm-4">푸시 알림 내용</div>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <label class="col-sm-2 col-form-label">푸시 알림 내용</label>
          <div class="col-sm-10">
            <div class="row">
              <div class="col-sm-2 text-center">ko</div>
              <div class="col-sm-4 text-center">
                <base-input placeholder="타이틀" v-model="title">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-4 text-center">
                <base-input placeholder="내용" v-model="body">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2 text-center">en</div>
              <div class="col-sm-4 text-center">
                <base-input placeholder="타이틀" v-model="title_en">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-4 text-center">
                <base-input placeholder="내용" v-model="body_en">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2 text-center">ja</div>
              <div class="col-sm-4 text-center">
                <base-input placeholder="타이틀" v-model="title_ja">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-4 text-center">
                <base-input placeholder="내용" v-model="body_ja">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div class="row">
          <label class="col-sm-2 col-form-label">파이어베이스 분석용 라벨</label>
          <div class="col-sm-4">
            <base-input placeholder="라벨" v-model="analyticsLabel" disabled>
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import * as _ from "lodash";
export default {
  components: {
    Card,
    BaseInput,
  },
  async created() {
    if (this.$route.query.id) {
      this.id = Number(this.$route.query.id);
      await this.getNotificationTemplate();
    }
  },
  data() {
    return {
      title: null,
      body: null,
      title_en: null,
      body_en: null,
      title_ja: null,
      body_ja: null,
      analyticsLabel: null,
      description: null,
      name: null,
    };
  },
  methods: {
    async getNotificationTemplate() {
      return this.$axios.get(`/notification/template/${this.id}`).then((res) => {
        const data = res.data.data;
        if (data) {
          this.analyticsLabel = data.analyticsLabel;
          this.body = data.body;
          this.description = data.description;
          this.name = data.name;
          this.title = data.title;
          const template = JSON.parse(data.template);
          const en = _.find(template, { lang: "en" });
          this.title_en = en.title;
          this.body_en = en.body;
          const ja = _.find(template, { lang: "ja" });
          this.title_ja = ja.title;
          this.body_ja = ja.body;
        }
      });
    },

    async onSubmit() {
      const param = {
        name: this.name,
        type: this.type,
        title: this.title,
        body: this.body,
        template: JSON.stringify([
          {
            lang: "ko",
            title: this.title,
            body: this.body,
          },
          {
            lang: "en",
            title: this.title_en,
            body: this.body_en,
          },
          {
            lang: "ja",
            title: this.title_ja,
            body: this.body_ja,
          },
        ]),

        description: this.description,
        analyticsLabel: this.analyticsLabel,
      };

      if (!this.name) {
        Toast.error("알림명을 입력해주세요");
        return;
      }
      if (!this.title || !this.title_en || !this.title_ja) {
        Toast.error("타이틀을 언어별로 입력해주세요");
        return;
      }

      if (this.id) {
        return this.$axios.put(`/notification/template/${this.id}`, param).then((res) => {
          Toast.success("등록되었습니다");
          this.$router.go(-1);
        });
      }
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.bootstrap-switch {
  margin: 6px;
}
</style>
